import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Card, CardContent, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import PesquisaPainel from "app/Core/Components/PesquisaPainel/PesquisaPainel";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import clsx from "clsx";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import CaixaCard from "./Components/CaixaCard";
import NaoRecebidoCard from "./Components/NaoRecebidoCard";
import EmpresaFinanceiroCaixaDialog from "./Dialog/EmpresaFinanceiroCaixaDialog";
import * as Actions from "./Store/Actions/EmpresaFinanceiroActions";


const styles = () => ({
    cardContent: {
        paddingBottom: "6px !important",
    },
    cardContentSelected: {
        boxShadow: "inset 0px 0px 6px 0px #fff",
    },
});

const parametros = {
    tipo: 5,
    filter: {
        AND: []
    }
};


const NewState = {
    open: null,
    inicio: Helpers.GetDataFirstDayMonth("usa"),
    termino: Helpers.GetDataLastDayMonth("usa"),
    forceRefresh: 0,
    filtro: ""
};

class EmpresaFinanceiroCaixaList extends XAPPComponent {

    state = { ...NewState };

    componentDidMount() {
        this.listFilter();
        this.setState(NewState);
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.getAcoes() === null ||
            !_.isEqual(this.props.data, prevProps.data)) {
            this.props.setAcoes(
                <React.Fragment>
                    {/* {this.props.data !== null &&
                        <ImprimirApp
                            data={this.props.data}
                            key="btnImprimir"
                            id="EmpresaFinanceiroCaixa"
                            label="CAIXA"
                            column={[]}
                        />
                    } */}
                </React.Fragment>
            );
        }

        if (!_.isNull(this.props.dataBase) && !_.isEqual(this.props.dataBase, prevProps.dataBase)) {
            this.setState({
                ...this.state,
                "inicio": Helpers.GetDataFirstDayMonth("usa", this.props.dataBase),
                "termino": Helpers.GetDataLastDayMonth("usa", this.props.dataBase),
                "forceRefresh": 1
            });
        }

        if (this.state.forceRefresh === 1 && !_.isEqual(this.state.forceRefresh, prevState.forceRefresh)) {
            this.listFilter();
            this.setState({
                ...this.state,
                "forceRefresh": 0
            });
        }
    }

    openDialog = (_AValue) => {
        this.setState({ open: _AValue });
        if (_.isNull(_AValue)) {
            this.props.clearApontamentos();
        }
    };

    listFilter = () => {
        const xappRouteParams = this.props.xappRouteParams;
        var AFilter = this.getFilter();
        this.props.listCaixa(xappRouteParams, AFilter);
    };

    getFilter = () => {
        const { responsavel = "all" } = this.props;
        const form = this.state;
        var AFilter = JSON.parse(JSON.stringify(parametros.filter));
        if (form.inicio !== null && form.inicio.length > 0 && form.termino !== null && form.termino.length > 0) {
            AFilter.AND = [];
            AFilter.AND.push({ "Campo": "datainicio", "Operador": ">=", "Valor": form.inicio + " 00:00:00" });
            AFilter.AND.push({ "Campo": "datafim", "Operador": "<=", "Valor": form.termino + " 23:59:59" });
            AFilter.AND.push({ "Campo": "responsavel", "Operador": "=", "Valor": responsavel });

        }
        else {
            AFilter.AND = [];
        }
        return AFilter;
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    canBeFilter = () => {
        const { inicio, termino } = this.state;
        return (
            inicio !== null && inicio !== "" &&
            termino !== null && termino !== ""
        );
    };

    changeFiltro = (_AValue) => {
        this.setState(_.set({ ...this.state }, "filtro", _AValue));
    };

    getTotais = (_AData) => {
        let AResponse = { "pendente": 0, "validado": 0, "todos": 0 };
        if (!_.isNull(_AData)) {
            _AData.forEach(item => {
                AResponse["todos"] += item.valortotalcaixa;
                if (item.validado > 0 && item.recebido === 0) {
                    AResponse["validado"] += item.valortotalcaixa;
                }
                else {
                    AResponse["pendente"] += item.valortotalcaixa;
                }
            });
        }

        return AResponse;
    };

    checkFiltro = (_AItem) => {
        const { filtro } = this.state;
        switch (filtro) {
            case "validado": return _AItem.validado > 0 && _AItem.recebido === 0;
            case "pendente": return _AItem.recebido > 0;
        }
    };

    render() {
        const { data, caixanaorecebido = null, classes, isGestor, onChangeDataBase, xappRouteParams, responsavel = "all", tipo } = this.props;
        const { filtro, inicio, termino, open } = this.state;
        let ATotais = this.getTotais(data);
        let AArray = [];
        const formatter = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
        switch (filtro) {
            case "naorecebido":
                AArray = !_.isNull(caixanaorecebido) ? caixanaorecebido : [];
                break;
            case "pendente":
            case "validado":
                AArray = !_.isNull(data) ? _.filter(data, x => this.checkFiltro(x)) : [];
                break;
            default:
                AArray = !_.isNull(data) ? data : [];
                break;
        }
        return (
            <React.Fragment>
                <PesquisaPainel
                    id={tipo}
                    anchor="left"
                    onRef={instance => this.PesquisaPainel = instance}
                >
                    <div className={"flex flex-col p-12 text-center items-center"}>
                        <TextField
                            className="mb-12"
                            id="inicio"
                            name="inicio"
                            label="Início"
                            value={inicio}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            className="mb-12"
                            id="termino"
                            name="termino"
                            label="Término"
                            value={termino}
                            onChange={this.handleChange}
                            variant="outlined"
                            type="date"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                    <div className="flex p-12 gap-6">
                        <div className="flex-1" />
                        <XAPPButton
                            className="text-white"
                            label="Pesquisar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="search"
                            iconProps="text-20 mr-8"
                            disabled={!this.canBeFilter()}
                            onClick={() => {
                                this.listFilter();
                                onChangeDataBase(inicio);
                                if (!_.isUndefined(this.PesquisaPainel)) {
                                    this.PesquisaPainel.togglePainel(tipo, 0, this.clearFiltro);
                                }
                            }}
                        />
                    </div>
                </PesquisaPainel>
                <div className="w-full overflow-x-auto overflow-y-hidden">
                    <div className="flex w-fit flex-row items-center gap-8 p-8">
                        <Card className={clsx("min-w-136 cursor-pointer")} onClick={() => this.changeFiltro("")}>
                            <CardContent className={clsx(classes.cardContent, "text-center py-6 px-12 w-full ", filtro === "" && classes.cardContentSelected)} >
                                <Typography className="text-20 whitespace-no-wrap w-full">{formatter.format(ATotais["todos"])}</Typography>
                                <Typography className="">{"Total recebido"}</Typography>
                            </CardContent>
                        </Card>
                        <Card className={clsx("min-w-136 cursor-pointer")} onClick={() => this.changeFiltro("pendente")}>
                            <CardContent className={clsx(classes.cardContent, "text-center py-6 px-12 w-full ", filtro === "pendente" && classes.cardContentSelected)} style={{ backgroundColor: "#F7C201" }}>
                                <Typography className="text-20 whitespace-no-wrap text-white w-full ">{formatter.format(ATotais["pendente"])}</Typography>
                                <Typography className="text-white">{"Pendente"}</Typography>
                            </CardContent>
                        </Card>
                        <Card className={clsx("min-w-136 cursor-pointer")} onClick={() => this.changeFiltro("validado")}>
                            <CardContent className={clsx(classes.cardContent, "text-center py-6 px-12 w-full ", filtro === "validado" && classes.cardContentSelected)} style={{ backgroundColor: "#00D935" }}>
                                <Typography className="text-20 whitespace-no-wrap text-white w-full ">{formatter.format(ATotais["validado"])}</Typography>
                                <Typography className="text-white">{"Aprovado"}</Typography>
                            </CardContent>
                        </Card>
                        {!_.isNull(caixanaorecebido) &&
                            <Card className={clsx("min-w-136 cursor-pointer")} onClick={() => this.changeFiltro("naorecebido")}>
                                <CardContent className={clsx(classes.cardContent, "text-center py-6 px-12 w-full", filtro === "naorecebido" && classes.cardContentSelected)} style={{ backgroundColor: "#FF7372" }}>
                                    <Typography className="text-20 whitespace-no-wrap text-white w-full">{caixanaorecebido.length}</Typography>
                                    <Typography className=" text-white">{"Alertas"}</Typography>
                                </CardContent>
                            </Card>
                        }
                    </div>
                </div>
                {filtro === "naorecebido" ?
                    <div className="flex flex-col w-full p-8">
                        {AArray.map((item, x) => (
                            <NaoRecebidoCard
                                key={x}
                                data={item}
                                xappRouteParams={xappRouteParams}
                                callback={() => this.listFilter()}
                            />
                        ))}
                    </div>
                    :
                    <div className="flex flex-col w-full p-8">
                        {AArray.map((item, x) => (
                            <CaixaCard
                                key={x}
                                data={item}
                                xappRouteParams={xappRouteParams}
                                openDialog={this.openDialog}
                                callback={() => this.listFilter()}
                            />
                        ))}
                    </div>
                }
                {AArray.length === 0 &&
                    <div className="w-full flex flex-col flex-1 items-center text-center">
                        <div className=" max-w-512 text-center p-16">
                            <FuseAnimate delay={500}>
                                <Typography variant="h6" color="textSecondary" className="mb-16">
                                    {"Não existem caixas neste período"}
                                </Typography>
                            </FuseAnimate>
                        </div>
                    </div>
                }
                <EmpresaFinanceiroCaixaDialog
                    open={open}
                    openDialog={this.openDialog}
                    xappRouteParams={xappRouteParams}
                    parametros={parametros}
                    getFilter={this.getFilter}
                    isGestor={isGestor}
                    responsavel={responsavel}
                />
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        listCaixa: Actions.listCaixa,
        clearApontamentos: Actions.clearApontamentos,
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroCaixaList)));
